export class DisabilityAccommodation{
    hmy:number;
    noStairs?:number;
    hearing?:number;
    wheelChair?:number;
    sight?:number;
    handRail?:number;
    
}